(() => {
  window.Express = window.Express || {};

  function toggle(current) {
    return !Boolean(current);
  }

  function setDisclosureState(options = {}) {
    const {
      button,
      panel,
      expanded,
      expandedClass = 'is-expanded',
      expandedIcon = '',
      collapsedIcon = '',
      expandedLabel = '',
      collapsedLabel = '',
    } = options;

    if (button) {
      button.classList.toggle(expandedClass, expanded);
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      const nextLabel = expanded ? expandedLabel : collapsedLabel;
      if (nextLabel) button.setAttribute('aria-label', nextLabel);

      const nextIcon = expanded ? expandedIcon : collapsedIcon;
      if (nextIcon) button.innerHTML = nextIcon;
    }

    if (panel) {
      panel.classList.toggle(expandedClass, expanded);
      panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    }
  }

  window.Express.productBuilderDisclosure = {
    toggle,
    setDisclosureState,
  };
})();
